/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PROJECT_STATUS = "DONE" | "HALTED" | "OPPORTUNITY" | "PLANNING" | "RUNNING" | "%future added value";
export type UpdateTimeRegInput = {|
  id?: ?string,
  ids?: ?$ReadOnlyArray<?string>,
  updateTimeRegLocation?: ?boolean,
  taskId?: ?string,
  idleTimeId?: ?string,
  projectId?: ?string,
  roleId?: ?string,
  year?: ?number,
  month?: ?number,
  day?: ?number,
  minutesRegistered?: ?number,
  billableMinutesRegistered?: ?number,
  retainerConflictHandled?: ?boolean,
  removeOthersForTheDay?: ?boolean,
  notes?: ?string,
  harvestTaskId?: ?string,
  retryHarvest?: ?boolean,
  unit4ActivityId?: ?string,
  unit4ActivityName?: ?string,
  skipApprovalValidation?: ?boolean,
  overrideInvoiced?: ?boolean,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type updateTimeRegistrationMutationModernMutationVariables = {|
  input: UpdateTimeRegInput
|};
export type updateTimeRegistrationMutationModernMutationResponse = {|
  +updateTimeReg: ?{|
    +timeReg: ?{|
      +id: string,
      +day: ?number,
      +month: ?number,
      +year: ?number,
      +canvasTimelineDate: ?number,
      +minutesRegistered: ?number,
      +billableMinutesRegistered: ?number,
      +role: ?{|
        +id: string,
        +name: ?string,
      |},
      +notes: ?string,
      +invoiced: ?boolean,
      +xeroInvoiceId: ?string,
      +lockedInPeriod: ?boolean,
      +harvestTimeId: ?number,
      +allocationId: ?string,
      +harvestTask: ?{|
        +id: string,
        +name: ?string,
      |},
      +harvestTaskIdInt: ?number,
      +harvestError: ?string,
      +unit4ActivityId: ?string,
      +unit4ActivityName: ?string,
      +project: ?{|
        +id: string,
        +name: ?string,
        +status: ?PROJECT_STATUS,
        +projectColor: ?string,
        +companyProjectId: ?number,
        +estimationUnit: ?string,
        +fullAccessToProject: ?boolean,
        +harvestProject: ?{|
          +id: string,
          +name: ?string,
        |},
        +unit4Project: ?{|
          +id: string,
          +name: ?string,
        |},
        +client: ?{|
          +id: string,
          +name: ?string,
        |},
      |},
      +task: ?{|
        +id: string,
        +name: ?string,
        +progress: ?number,
        +companyTaskId: ?number,
        +highPriority: ?boolean,
        +approved: ?boolean,
        +favoured: ?boolean,
        +fullAccessToProject: ?boolean,
        +latestUiUpdateAt: ?string,
        +timeLeft: ?number,
        +timeLeftMinutesWithoutFutureTimeRegs: ?number,
        +totalMinutesRegistered: ?number,
        +project: ?{|
          +id: string,
          +name: ?string,
          +status: ?PROJECT_STATUS,
          +companyProjectId: ?number,
          +projectColor: ?string,
          +estimationUnit: ?string,
          +fullAccessToProject: ?boolean,
          +client: ?{|
            +id: string,
            +name: ?string,
          |},
          +harvestProject: ?{|
            +id: string,
            +name: ?string,
          |},
          +unit4Project: ?{|
            +id: string,
            +name: ?string,
          |},
        |},
        +phase: ?{|
          +id: string,
          +name: ?string,
        |},
      |},
      +idleTime: ?{|
        +id: string,
        +name: ?string,
        +isInternalTime: ?boolean,
        +favoured: ?boolean,
      |},
      +person: ?{|
        +id: string,
        +firstName: ?string,
        +lastName: ?string,
        +isViewer: ?boolean,
      |},
    |},
    +deletedTimeRegIds: ?$ReadOnlyArray<?string>,
    +task: ?{|
      +timeLeft: ?number,
      +totalMinutesRegistered: ?number,
      +currentPrice: ?number,
      +allTotalTimeAndExpensesAtCompletion: ?number,
      +progress: ?number,
    |},
    +errors: ?$ReadOnlyArray<?string>,
  |}
|};
export type updateTimeRegistrationMutationModernMutation = {|
  variables: updateTimeRegistrationMutationModernMutationVariables,
  response: updateTimeRegistrationMutationModernMutationResponse,
|};
*/


/*
mutation updateTimeRegistrationMutationModernMutation(
  $input: UpdateTimeRegInput!
) {
  updateTimeReg(input: $input) {
    timeReg {
      id
      day
      month
      year
      canvasTimelineDate
      minutesRegistered
      billableMinutesRegistered
      role {
        id
        name
      }
      notes
      invoiced
      xeroInvoiceId
      lockedInPeriod
      harvestTimeId
      allocationId
      harvestTask {
        id
        name
      }
      harvestTaskIdInt
      harvestError
      unit4ActivityId
      unit4ActivityName
      project {
        id
        name
        status
        projectColor
        companyProjectId
        estimationUnit
        fullAccessToProject
        harvestProject {
          id
          name
        }
        unit4Project {
          id
          name
        }
        client {
          id
          name
        }
      }
      task {
        id
        name
        progress
        companyTaskId
        highPriority
        approved
        favoured
        fullAccessToProject
        latestUiUpdateAt
        timeLeft
        timeLeftMinutesWithoutFutureTimeRegs
        totalMinutesRegistered
        project {
          id
          name
          status
          companyProjectId
          projectColor
          estimationUnit
          fullAccessToProject
          client {
            id
            name
          }
          harvestProject {
            id
            name
          }
          unit4Project {
            id
            name
          }
        }
        phase {
          id
          name
        }
      }
      idleTime {
        id
        name
        isInternalTime
        favoured
      }
      person {
        id
        firstName
        lastName
        isViewer
      }
    }
    deletedTimeRegIds
    task {
      timeLeft
      totalMinutesRegistered
      currentPrice
      allTotalTimeAndExpensesAtCompletion
      progress
      id
    }
    errors
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateTimeRegInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  (v2/*: any*/),
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectColor",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimationUnit",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullAccessToProject",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "HarvestProjectType",
  "kind": "LinkedField",
  "name": "harvestProject",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Unit4ProjectType",
  "kind": "LinkedField",
  "name": "unit4Project",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Client",
  "kind": "LinkedField",
  "name": "client",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progress",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "favoured",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeLeft",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalMinutesRegistered",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "TimeRegType",
  "kind": "LinkedField",
  "name": "timeReg",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "day",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "month",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "year",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canvasTimelineDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minutesRegistered",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billableMinutesRegistered",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Role",
      "kind": "LinkedField",
      "name": "role",
      "plural": false,
      "selections": (v4/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "invoiced",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "xeroInvoiceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lockedInPeriod",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "harvestTimeId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allocationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HarvestTaskType",
      "kind": "LinkedField",
      "name": "harvestTask",
      "plural": false,
      "selections": (v4/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "harvestTaskIdInt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "harvestError",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unit4ActivityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unit4ActivityName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v3/*: any*/),
        (v5/*: any*/),
        (v6/*: any*/),
        (v7/*: any*/),
        (v8/*: any*/),
        (v9/*: any*/),
        (v10/*: any*/),
        (v11/*: any*/),
        (v12/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Task",
      "kind": "LinkedField",
      "name": "task",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v3/*: any*/),
        (v13/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "companyTaskId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "highPriority",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "approved",
          "storageKey": null
        },
        (v14/*: any*/),
        (v9/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "latestUiUpdateAt",
          "storageKey": null
        },
        (v15/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timeLeftMinutesWithoutFutureTimeRegs",
          "storageKey": null
        },
        (v16/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectType",
          "kind": "LinkedField",
          "name": "project",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v3/*: any*/),
            (v5/*: any*/),
            (v7/*: any*/),
            (v6/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v12/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PhaseType",
          "kind": "LinkedField",
          "name": "phase",
          "plural": false,
          "selections": (v4/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IdleTime",
      "kind": "LinkedField",
      "name": "idleTime",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isInternalTime",
          "storageKey": null
        },
        (v14/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "person",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isViewer",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedTimeRegIds",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentPrice",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allTotalTimeAndExpensesAtCompletion",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateTimeRegistrationMutationModernMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateTimeRegPayload",
        "kind": "LinkedField",
        "name": "updateTimeReg",
        "plural": false,
        "selections": [
          (v17/*: any*/),
          (v18/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "task",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              (v16/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v13/*: any*/)
            ],
            "storageKey": null
          },
          (v21/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateTimeRegistrationMutationModernMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateTimeRegPayload",
        "kind": "LinkedField",
        "name": "updateTimeReg",
        "plural": false,
        "selections": [
          (v17/*: any*/),
          (v18/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "task",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              (v16/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v13/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v21/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateTimeRegistrationMutationModernMutation",
    "operationKind": "mutation",
    "text": "mutation updateTimeRegistrationMutationModernMutation(\n  $input: UpdateTimeRegInput!\n) {\n  updateTimeReg(input: $input) {\n    timeReg {\n      id\n      day\n      month\n      year\n      canvasTimelineDate\n      minutesRegistered\n      billableMinutesRegistered\n      role {\n        id\n        name\n      }\n      notes\n      invoiced\n      xeroInvoiceId\n      lockedInPeriod\n      harvestTimeId\n      allocationId\n      harvestTask {\n        id\n        name\n      }\n      harvestTaskIdInt\n      harvestError\n      unit4ActivityId\n      unit4ActivityName\n      project {\n        id\n        name\n        status\n        projectColor\n        companyProjectId\n        estimationUnit\n        fullAccessToProject\n        harvestProject {\n          id\n          name\n        }\n        unit4Project {\n          id\n          name\n        }\n        client {\n          id\n          name\n        }\n      }\n      task {\n        id\n        name\n        progress\n        companyTaskId\n        highPriority\n        approved\n        favoured\n        fullAccessToProject\n        latestUiUpdateAt\n        timeLeft\n        timeLeftMinutesWithoutFutureTimeRegs\n        totalMinutesRegistered\n        project {\n          id\n          name\n          status\n          companyProjectId\n          projectColor\n          estimationUnit\n          fullAccessToProject\n          client {\n            id\n            name\n          }\n          harvestProject {\n            id\n            name\n          }\n          unit4Project {\n            id\n            name\n          }\n        }\n        phase {\n          id\n          name\n        }\n      }\n      idleTime {\n        id\n        name\n        isInternalTime\n        favoured\n      }\n      person {\n        id\n        firstName\n        lastName\n        isViewer\n      }\n    }\n    deletedTimeRegIds\n    task {\n      timeLeft\n      totalMinutesRegistered\n      currentPrice\n      allTotalTimeAndExpensesAtCompletion\n      progress\n      id\n    }\n    errors\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '838316882824a4325f609bafe3fea6d1';

module.exports = node;
